import React from 'react';
import { format, parseISO } from 'date-fns';
import { Meeting } from '../../../shared/types';
import { useTimezone } from '../../../context/TimezoneContext';
import { convertToZonedTime } from '../../../utils/datetime';

interface MeetingEventProps {
  meeting: Meeting;
  onClick: () => void;
}

const getStatusColor = (status: string | null | undefined) => {
  switch (status) {
    case 'Positiva - Cerrado':
      return 'bg-green-700 border-green-700 text-green-100'; // Dark green, white text
    case 'Positiva - Seguimiento':
      return 'bg-green-100 border-green-200 text-green-800'; // Pale green
    case 'Negativa':
      return 'bg-red-200 border-red-300 text-red-800'; // Pale red
    case 'Negativa - Perfil inadecuado':
      return 'bg-red-700 border-red-700 text-red-100'; // Dark red, white text
    case 'No se ha presentado':
      return 'bg-blue-200 border-blue-300 text-blue-900'; // Pale dark blue
    case 'No nos hemos presentado':
      return 'bg-blue-100 border-blue-200 text-blue-800'; // Pale clear blue
    case 'Sin respuesta':
      return 'bg-gray-300 border-gray-400 text-gray-800'; // Mid gray — lead went silent
    case 'Cancelada':
      return 'bg-gray-800 border-gray-800 text-gray-100'; // Dark gray, light text
    default:
      return 'bg-gray-100 border-gray-200 text-gray-800'; // Default (gray)
  }
};

export const MeetingEvent: React.FC<MeetingEventProps> = ({ meeting, onClick }) => {
  const { timezone } = useTimezone();
  const utcDate = parseISO(meeting.fields['Fecha Reunión']);
  const meetingDate = convertToZonedTime(utcDate, timezone);
  const statusColor = getStatusColor(meeting.fields['Status Lead']);

  return (
    <button
      onClick={onClick}
      className={`w-full text-left px-2 py-0.5 border ${statusColor} text-xs transition-colors hover:opacity-90 truncate`}
    >
      {format(meetingDate, 'HH:mm')} - {meeting.fields.Nombre}
    </button>
  );
};